import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import "./LandingPage.css";
import { selectUser } from "../../features/userSlice";

const LandingPage = () => {
  const user = useSelector(selectUser);
  const token = user?.token;
  const navigate = useNavigate();

  useEffect(() => {
    if (token) {
      navigate("/dashboard");
    }
  }, [token, navigate]);

  return (
    <div className="landing-page-root">
      <div className="landing-content">
        <h1 className="landing-brand">Singhal Logistics</h1>
        <p className="landing-headline">Logistics Operation</p>
        <p className="landing-subtitle">
          Yard, weighbridge & vehicle movement — managed in one place.
        </p>

        {!token && (
          <div className="buttonContainer">
            <a href="/login">
              <button className="landingbutton">Get Started</button>
            </a>
          </div>
        )}
      </div>
      <footer className="landing-footer">
        © {new Date().getFullYear()} Singhal Group | All Rights Reserved.
      </footer>
    </div>
  );
};

export default LandingPage;
